import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Phone, MessageCircle } from 'lucide-react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BookingForm } from './BookingForm';
import { Button } from './ui/button';
import { PHONE_DISPLAY, PHONE_TEL } from '../data/seoPages';

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-1 text-sm text-gray-400 mb-6">
    <Link to="/" className="hover:text-[#d4af37]">Home</Link>
    {items.map((item) => (
      <React.Fragment key={item.label}>
        <ChevronRight className="w-4 h-4 text-gray-600" aria-hidden="true" />
        {item.to ? <Link to={item.to} className="hover:text-[#d4af37]">{item.label}</Link> : <span className="text-gray-200">{item.label}</span>}
      </React.Fragment>
    ))}
  </nav>
);

export const CallCtas = ({ message }) => (
  <div className="flex flex-col sm:flex-row gap-4">
    <a href={`tel:${PHONE_TEL}`} data-testid="seo-call-btn">
      <Button className="w-full sm:w-auto rounded-full bg-[#d4af37] hover:bg-[#c9a35c] text-black font-semibold px-8 h-12">
        <Phone className="w-4 h-4 mr-2" aria-hidden="true" /> Call {PHONE_DISPLAY}
      </Button>
    </a>
    <a href={`https://wa.me/${PHONE_TEL.replace('+', '')}?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer" data-testid="seo-whatsapp-btn">
      <Button variant="outline" className="w-full sm:w-auto rounded-full border-[#d4af37]/50 text-[#d4af37] hover:bg-[#d4af37]/10 hover:text-[#f0d47a] bg-transparent px-8 h-12">
        <MessageCircle className="w-4 h-4 mr-2" aria-hidden="true" /> WhatsApp a quote
      </Button>
    </a>
  </div>
);

export const SeoPageLayout = ({ children }) => (
  <div className="bg-[#0a0a0a] min-h-screen">
    <Header />
    <main className="pt-28">{children}</main>
    <BookingForm />
    <Footer />
  </div>
);
